import React from 'react';

const DeviceMenuList = ({
  devices = [],
  activeDeviceId = '',
  onSelect,
  menuAriaLabel,
  menuClassName,
  menuStyle,
  itemClassName,
  getItemStyle,
}) => (
  <div
    className={menuClassName}
    style={menuStyle}
    role="menu"
    aria-label={menuAriaLabel}
  >
    {(devices || []).map((device) => {
      const isActive = activeDeviceId === device.deviceId;
      return (
        <button
          key={device.deviceId}
          type="button"
          className={itemClassName ? itemClassName(isActive, device) : ''}
          style={getItemStyle ? getItemStyle(isActive, device) : undefined}
          onClick={() => onSelect?.(device.deviceId)}
        >
          {device.label || device.deviceId}
        </button>
      );
    })}
  </div>
);

export default DeviceMenuList;
